import type { Garage } from '@parkeze/map-kit/map/floors/floors'
import type { Facility } from '@/types'

/** A facility as map-kit's floors draw it (decision 49): each floor with what is free on it. */
export function toGarage(f: Facility): Garage {
  return {
    id: f.facility_id,
    name: f.name,
    footprint: f.footprint as GeoJSON.Polygon | null,
    lng: f.center_coordinates?.lon ?? null,
    lat: f.center_coordinates?.lat ?? null,
    // A garage's own 3D model would cover its spaces; a lot's or a street's may be a landmark.
    clearBasemap: f.kind === 'garage',
    floors: f.levels.map((l) => ({
      id: l.level_id,
      ordinal: l.ordinal,
      name: l.name,
      shortName: l.short_name,
      elevationM: l.elevation_m,
      outline: l.outline as GeoJSON.Polygon | null,
      free: l.free,
      capacity: l.capacity,
      approximate: l.counted_by === 'estimate',
    })),
  }
}
